import React from "react";
import ProcessHero from "../container/processHero/ProcessHero";
import ProcessDesign from "../container/processDesign/ProcessDesign";
import ProcessContents from "../container/processContents/ProcessContents";
import ProcessExpect from "../container/processExpect/ProcessExpect";
import ProcessService from "../container/processService/ProcessService";
import HomeFAQ from "../container/homeFAQ/HomeFAQ";
import { Helmet } from "react-helmet-async";

const Process = () => {
  return (
    <>
      <Helmet>
        <title>Process - Radiksez</title>
        <meta
          name="description"
          content="Radiksez process on software development, quality assurance, social media management, and AI & ML validation."
        />
        <link rel="canonical" href="https://radiksez.com/our-process" />
      </Helmet>
      <ProcessHero />
      <ProcessDesign />
      <ProcessContents />
      <ProcessExpect />
      <ProcessService />
      <HomeFAQ />
    </>
  );
};

export default Process;
